import { render, staticRenderFns } from "./CoreValuesFourIcon.vue?vue&type=template&id=d2730a22&"
import script from "./CoreValuesFourIcon.vue?vue&type=script&lang=js&"
export * from "./CoreValuesFourIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports